import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AlertIcon } from './resources/icon_alert.svg';
import './ErrorBlock.css';

const ErrorBlock = ({ errorCode }) => {
    const { t } = useTranslation();

    return (
        <div className="wz-lyriapay-errorblock">
            <div className="wz-lyriapay-errorblock-icon">
                <AlertIcon />
            </div>
            <div className="wz-lyriapay-errorblock-content">
                { t([`error_${errorCode}`, 'error_PSPError']) }
            </div>
        </div>
    );
};

ErrorBlock.propTypes = {
    errorCode: PropTypes.string.isRequired
};

export default ErrorBlock;
